/**
 * Vector management for CDP SDK.
 */

import { CDPSession, getSession } from '../session';

export class VectorManager {
  constructor(private readonly session: CDPSession = getSession()) {}

  async exportVector(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/cdp_vector/extend/exportVector', {
      params,
      responseType: 'blob',
    });
  }

  async uploadVector(file: File | Blob, params?: Record<string, any>): Promise<Record<string, any>> {
    const formData = new FormData();
    formData.append('file', file);
    return this.session.post('/api/cdp/cdp_vector/extend/uploadVector', {
      data: formData,
      params,
      headers: {},
    });
  }

  async exportModel(params?: Record<string, any>): Promise<Blob> {
    return this.session.request('GET', '/api/cdp/cdp_vector/extend/exportModel', {
      params,
      responseType: 'blob',
    });
  }

  async existFile(params?: Record<string, any>): Promise<Record<string, any>> {
    return this.session.get('/api/cdp/cdp_vector/extend/existFile', { params });
  }

  async batchCopyVector(data: {
    srcUuids: string[];
    suffix?: string;
    tag?: string;
    dirType?: number;
    projectUuid?: string;
    catalogUuid?: string;
  }): Promise<Record<string, any>> {
    return this.session.post('/api/cdp/cdp_vector/extend/batchCopyVector', { data });
  }
}
